import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
// import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';

@Component({
  selector: 'app-prepaid-expense-report',
  templateUrl: './prepaid-expense-report.component.html',
  styleUrls: ['./prepaid-expense-report.component.css']
})
export class PrepaidExpenseReportComponent implements OnInit {

  public menu_item_id = '64';
  
  private dp = [];
  displayedColumns = ['acct_number', 'acct_name', 'total', 'voucher_date',
    'paid', 'date', 'remaining', 'supplier_name'];

  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = { 'title': 'مصروفات مدفوعة مقدماً' };

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList) { }

  ngOnInit() {
  }

  print() {
    let html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"><h2> مصروفات مدفوعة مقدماً </h2></td></tr>';
    html_data += '</table>';

    let form = (document.getElementById('form1') as HTMLFormElement);
    let table = (document.getElementById('rep_table2') as HTMLTableElement);
    this.utils.printReport(html_data, [{ table: table }], form, 'PDF');

  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }
}
